
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import type { Prize, University } from "./types";

interface AllocationFormProps {
  prizes: Prize[];
  universities: University[];
  formData: {
    university_id: string;
    prize_id: string;
    daily_limit: number;
  };
  setFormData: (data: {
    university_id: string;
    prize_id: string;
    daily_limit: number;
  }) => void;
  onSubmit: (e: React.FormEvent) => void;
}

export function AllocationForm({
  prizes,
  universities,
  formData,
  setFormData,
  onSubmit
}: AllocationFormProps) {
  return (
    <form onSubmit={onSubmit} className="space-y-4">
      <Select
        value={formData.university_id}
        onValueChange={(value) => setFormData({ ...formData, university_id: value })}
      >
        <SelectTrigger>
          <SelectValue placeholder="Select University" />
        </SelectTrigger>
        <SelectContent>
          {universities.map((university) => (
            <SelectItem key={university.id} value={university.id.toString()}>
              {university.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      <Select
        value={formData.prize_id}
        onValueChange={(value) => setFormData({ ...formData, prize_id: value })}
      >
        <SelectTrigger>
          <SelectValue placeholder="Select Prize" />
        </SelectTrigger>
        <SelectContent>
          {prizes.map((prize) => (
            <SelectItem key={prize.id} value={prize.id.toString()}>
              {prize.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      <Input
        type="number"
        min="1"
        placeholder="Daily Limit"
        value={formData.daily_limit}
        onChange={(e) => setFormData({ ...formData, daily_limit: parseInt(e.target.value) })}
        required
      />
      <Button type="submit">
        {formData.university_id ? 'Update' : 'Add'} Allocation
      </Button>
    </form>
  );
}
